import { FormInstance } from 'antd/lib/form';
import { TabErrors, TabFields } from '../types/validateErrorType';
import React from 'react';

const checkTabForErrors = (fields: string[], form: FormInstance): boolean => {
    const fieldsError = form.getFieldsError();
    for (const field of fields) {
        // for nested field eg: ["Appointment", "DropOffTime"] & Appointment.DropOffTime
        const fieldParts = typeof field === 'string' ? field.split('.') : field;
        const fieldError = fieldsError.find((item: any) => {
            if (!fieldParts || item.name.length !== fieldParts.length) return false;
            return fieldParts.every((part, index) => item.name[index] === part);
        });
        if (fieldError?.errors.length! > 0) {
            return true;
        }
    }
    return false;
};

export const updateAllTabErrorStates = (tabFields: TabFields, form: FormInstance, 
setTabErrors: (errors: TabErrors | ((prev: TabErrors) => TabErrors)) => void) => {
    setTabErrors((prevTabErrors) => {
        const newTabErrors = { ...prevTabErrors };
        Object.keys(tabFields).forEach((tabKey) => {
            newTabErrors[tabKey] = checkTabForErrors(tabFields[tabKey] as string[], form);
        });
        return newTabErrors;
    });
};

export const updateFormErrors = (form: FormInstance, setFormErrors: (errors: string[]) => void) => {
    const fieldsError = form.getFieldsError();
    const errors: string[] = [];
    fieldsError.forEach((field: any) => {
        if (field.errors.length > 0) {
            errors.push(`${field.errors[0]}`);
        }
    });
    setFormErrors(errors);
};